<script setup lang="ts">
import { formatDate } from '@/utils/dateFormatter'
import { computed } from 'vue'

const props = defineProps<{
	responsables: any[]
	type: string
}>()

const responsableFiltered = computed(() => {
	if (props.type === 'certificados') {
		return props.responsables.filter(responsable => Boolean(responsable.certificates))
	} else if (props.type === 'titulos') {
		return props.responsables.filter(responsable => Boolean(responsable.degrees))
	}
	return []
})
</script>
<template>
	<VaCard v-for="responsable in responsableFiltered" :key="responsable.id" style="margin-bottom: 10px">
		<va-card-title class="text-center mb-2">
			<div class="row align-items-center">
				<div class="col-md-12text-center">
					<div class="row">
						<div class="col-md-8 text-left">
							<div>
								<VaAvatar icon="person" color="#062342" size="small" style="margin-right: 10px" />
								<span class="certificate-name">{{ responsable.nombre }} {{ responsable.primerApellido }} {{ responsable.segundoApellido }}</span>
							</div>
						</div>
						<div class="col-md-4">
							<div>CURP : {{ responsable.curp }}</div>
							<div>Tel. : {{ responsable.phone }}</div>
							<div>Cargo : {{ props.type === 'certificados' ? responsable.certificates?.cargo : responsable.degrees?.cargo }}</div>
						</div>
					</div>
				</div>
			</div>
		</va-card-title>
		<VaCardContent>
			<div class="info-card-content">
				<!-- Información de la e.firma -->
				<div style="font-weight: bold; margin-bottom: 8px">Información de la e.firma</div>
				<table class="firma-table">
					<tbody>
						<tr v-for="([key, value], idx) in Object.entries(responsable.cer?.x509?.subject || {})" :key="key" :class="{ 'alt-row': idx % 2 === 0 }">
							<th>{{ key }}</th>
							<td>{{ value }}</td>
						</tr>
						<tr>
							<th>serial</th>
							<td>{{ responsable.cer.x509.serial }}</td>
						</tr>
					</tbody>
				</table>
				<!-- Estados -->
				<div style="margin-bottom: 8px">
					<VaAlert v-if="responsable.cer?.x509" color="success" icon="check_circle" class="mb-2"> El certificado público está correctamente cargado en el sistema </VaAlert>
					<VaAlert v-else color="danger" icon="error" class="mb-2"> No hay certificado público cargado en el sistema </VaAlert>
				</div>
				<!-- Folio y vigencia -->
				<div style="display: flex; align-items: center; margin-bottom: 8px">
					<VaIcon name="description" color="success" />
					<span style="margin-left: 8px">
						Folio del certificado SAT : <b>#{{ responsable.cer?.x509?.serialNumber || responsable.curp }}</b>
					</span>
				</div>
				<div style="display: flex; align-items: center">
					<VaIcon name="event" color="success" />
					<span style="margin-left: 8px">
						Vigencia al <b>{{ formatDate(responsable.cer?.x509?.notAfter) }}</b>
					</span>
				</div>
			</div>
		</VaCardContent>
	</VaCard>
</template>
<style scoped>
.certificate-name {
	font-weight: 600;
	text-transform: capitalize;
	font-size: 15px;
	letter-spacing: 0.5px;
	color: #222;
}
.firma-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	margin-bottom: 12px;
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.firma-table th {
	background: #f0f4fa;
	color: #1a2a3a;
	font-weight: 600;
	text-align: left;
	padding: 8px 12px;
	width: 220px;
	border-bottom: 1px solid #e0e6ed;
}

.firma-table td {
	background: #fafbfc;
	color: #3a4a5a;
	padding: 8px 12px;
	border-bottom: 1px solid #e0e6ed;
}

.firma-table tr:last-child th,
.firma-table tr:last-child td {
	border-bottom: none;
}

.firma-table .alt-row th,
.firma-table .alt-row td {
	background: #f7fafd;
}
</style>
